<template>
  <div class="page">
    <div class="header-menu">
      <header-bar slot="head" navStyle="padding-left:.266rem;padding-right:.266rem;">
        <span slot="left">{{ $t("mall_modules_editrole_fanhui") }}</span>
        <span>{{ $t(objSave.centerTitle) }}</span>
      </header-bar>
      <div @click="addAddress('')" class="addressInfos-btn">
        <i class="fa fa-plus"></i>
        <span>{{ $t("mall.NewCommonAddresses") }}</span>
      </div>
    </div>
    <div class="page-content">
      <Scroll
        :data="model.AddressInfos"
        ref="scroll"
        :scrollbar="scrollbarObj"
        :pullUpLoad="pullUpLoadObj"
        :startY="parseInt(startY)"
        @pullingUp="onPullingUp"
        :pullDownRefresh="pullDownRefreshObj"
        @pullingDown="onPullingDown"
      >
        <ul>
          <li>
            <div class="addressInfos">
              <table border="0" cellspacing="0" cellpadding="0">
                <tr v-for="(AddressInfo, index) in model.AddressInfos" @click="addAddress(AddressInfo.ContactID)">
                  <td>
                    <span @click="handleCheckbox" v-if="AddressInfo.IsDefault == 1150">{{ $t("mall.default") }}</span>
                    <label @click="handleCheckbox" v-else :for="AddressInfo.AddressID">
                      <input @change="changeCheckbox($event, AddressInfo)" type="checkbox" :value="AddressInfo" v-model="model.selectAddress" :id="AddressInfo.AddressID" />
                    </label>
                  </td>
                  <td>
                    <div>
                      <p>
                        <span>{{ AddressInfo.ContactName ? AddressInfo.ContactName : "---" }}</span>
                        <span>{{ AddressInfo.ContactPhone ? AddressInfo.ContactPhone : "---" }}</span>
                      </p>
                      <p>
                        <span>{{ AddressInfo.Address ? AddressInfo.Address : "---" }}</span>
                      </p>
                    </div>
                    <img src="/static/img/left1.png" />
                  </td>
                </tr>
              </table>
            </div>
          </li>
        </ul>
      </Scroll>
    </div>
  </div>
</template>
<style scoped>
  .addressInfos table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0px 10px;
  }

  .addressInfos table tr {
    background-color: #fff;
    margin-bottom: 0.266rem;
  }

  .addressInfos table td:first-child {
    height: 1.276rem;
    width: 1.276rem;
    text-align: center;
  }

  .addressInfos table td:last-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 0.266rem;
    padding: 0.266rem 0.266rem 0.266rem 0;
  }
  .addressInfos table img {
    width: 0.372rem;
    vertical-align: middle;
  }
  p {
    margin: 0;
    padding: 0;
  }

  .header-menu {
    height: 3.557rem;
  }

  .header-menu header {
    background-color: #12a3ff;
  }

  .appInner .header-menu ~ .page-content {
    top: 3.458rem;
  }
  .iphoneX .header-menu ~ .page-content {
    top: 1.5rem;
  }
  .header-menu ~ .page-content {
    top: 3.557rem;
  }

  .checkBox {
    width: 1.276rem;
    height: 1.276rem;
  }

  .checkBox input {
    transform: translate3d(50%, 50%, 0);
    width: 0.478rem;
    height: 0.478rem;
  }

  .addressInfos-btn {
    border: 1px solid rgb(18, 163, 255);
    border-radius: 0.106rem;
    text-align: center;
    padding: 0.133rem 0;
    margin: 0.266rem 0.532rem;
    font-size: 0.425rem;
  }

  .addressInfos-btn i {
    font-size: 0.478rem;
    color: #12a3ff;
    vertical-align: middle;
  }

  .addressInfos-btn span {
    color: #12a3ff;
    vertical-align: middle;
  }

  .addressInfos-item {
    background-color: #fff;
    margin-bottom: 0.266rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 1.596rem;
    padding-right: 0.266rem;
  }

  .addressInfos-item > div:last-child i {
    font-size: 0.478rem;
    color: #999;
  }

  .addressInfos-leftItem > span {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .addressInfos-leftItem {
    display: flex;
  }

  .addressInfos-leftItem > div {
    align-self: center;
  }
</style>

<script>
  import Scroll from "./modules/Scroll.vue";
  import navBar from "./modules/navBar.vue";
  import UserService from "@/service/UserService";
  import { YesOrNo } from "@/model/Base";
  export default {
    data() {
      return {
        scrollbar: false,
        scrollbarFade: true,
        pullDownRefresh: true,
        pullDownRefreshThreshold: 90,
        pullDownRefreshStop: 40,
        pullUpLoad: true,
        pullUpLoadThreshold: 0,
        pullUpLoadMoreTxt: "share.pullUpLoadMoreTxt",
        pullUpLoadNoMoreTxt: "share.pullUpLoadNoMoreTxt",
        startY: 0,
        scrollToX: 0,
        scrollToY: -200,
        scrollToTime: 700,
        scrollToEasing: "bounce",
        scrollToEasingOptions: ["bounce", "swipe", "swipeBounce"],
        model: {
          selectAddress: [],
          AddressInfos: [],
        },
        Search: {
          PageNo: 1,
          PageSize: 15,
          RoleID: "",
        },
        Flag: false,
        objSave: {
          centerTitle: "mall.ConsigneeAddress",
          rightTitle: {
            isShow: true,
            type: "button",
            label: "share.confirmTxt",
            fnName: "fnSave",
          },
        },
      };
    },
    watch: {
      scrollbarObj: {
        handler() {
          this.rebuildScroll();
        },
        deep: true,
      },
      pullDownRefreshObj: {
        handler() {
          this.rebuildScroll();
        },
        deep: true,
      },
      pullUpLoadObj: {
        handler() {
          this.rebuildScroll();
        },
        deep: true,
      },
      startY() {
        this.rebuildScroll();
      },
    },
    computed: {
      CompanyID() {
        return this.profile.CompanyID;
      },
      scrollbarObj() {
        return this.scrollbar
          ? {
              fade: this.scrollbarFade,
            }
          : false;
      },
      pullUpLoadObj() {
        return this.pullUpLoad
          ? {
              threshold: parseInt(this.pullUpLoadThreshold),
              txt: {
                more: this.pullUpLoadMoreTxt,
                noMore: this.pullUpLoadNoMoreTxt,
              },
            }
          : false;
      },
      pullDownRefreshObj() {
        return this.pullDownRefresh
          ? {
              threshold: parseInt(this.pullDownRefreshThreshold),
              stop: parseInt(this.pullDownRefreshStop),
            }
          : false;
      },
    },
    mounted() {
      let __self = this;
      if (__self.$route.path == "/system/address") {
        __self.objSave.rightTitle = {};
      }
    },
    activated() {
      let __self = this;
      if (__self.$route.path == "/system/address") {
        __self.objSave.rightTitle = {};
      } else {
        __self.objSave.rightTitle = {
          isShow: true,
          type: "button",
          label: "share.confirmTxt",
          fnName: "fnSave",
        };
      }
      __self.__init();
    },
    methods: {
      __init() {
        let __self = this;
        __self.Search.RoleID = this.profile.UserID;
        UserService.getContactList(__self.Search).then(function(json) {
          if (json.isSucc) {
            if (json.result.entities.length > 0) {
              if (__self.Search.PageNo <= 1) {
                __self.model.AddressInfos = json.result.entities;
              } else {
                __self.model.AddressInfos = _.concat(__self.model.AddressInfos, json.result.entities);
              }
            } else {
              __self.$refs.scroll.forceUpdate();
            }
          }
        });
      },
      handleCheckbox(e) {
        e.stopPropagation();
      },
      addAddress(ContactID) {
        let query = {};
        if (ContactID != "") {
          query.ContactID = ContactID;
        }
        let __self = this;
        __self.$router.push({
          path: "/system/NewAddress",
          query: query,
        });
      },
      changeCheckbox(e, value) {
        let __self = this;
        if (e.target.checked && __self.model.selectAddress.lenght > 0 != undefined) {
          _.remove(__self.model.selectAddress, function(o) {
            return o != value;
          });
        }
      },
      Save() {
        let __self = this;
        if (__self.model.selectAddress.length <= 0) {
          __self.model.selectAddress = [];
          for (let i = 0; i < __self.model.AddressInfos.length; i++) {
            let AddressInfo = __self.model.AddressInfos[i];
            if (AddressInfo.IsDefault == YesOrNo.Yes) {
              __self.model.selectAddress.push(AddressInfo);
            }
          }
        }
        $utils.Storage.AddressInfo = JSON.stringify(__self.model.selectAddress);
        history.back();
      },
      scrollTo() {
        this.$refs.scroll.scrollTo(this.scrollToX, this.scrollToY, this.scrollToTime, ease[this.scrollToEasing]);
      },
      onPullingUp() {
        let __self = this;
        __self.Search.PageNo++;
        __self.__init();
      },
      onPullingDown() {
        let __self = this;
        __self.Search.PageNo = 1;
        __self.__init();
      },
      rebuildScroll() {
        let __self = this;
        __self.$nextTick(() => {
          __self.$refs.scroll.destroy();
          __self.$refs.scroll.initScroll();
        });
      },
    },
    components: {
      navBar,
      Scroll,
    },
  };
</script>
